export default "__VITE_ASSET__BnhjQkWt__"